module.exports = __webpack_public_path__ + "static/media/grayStatusIcon.9cb1959b.svg";